// HTML escape helpers — used wherever external data is interpolated into innerHTML.
// `escapeHtml` is safe for text-node positions. `escapeAttr` is for attribute values
// (also escapes quotes so payloads can't break out of `value="..."`).

const HTML_ENTITIES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;',
  '=': '&#61;',
};

export function escapeHtml(v) {
  if (v == null) return '';
  return String(v).replace(/[&<>"'`=]/g, (c) => HTML_ENTITIES[c]);
}

// For attribute values. Same as escapeHtml but the semantic distinction matters
// for reviewers — and lets us tighten attr-only escaping later if needed.
export const escapeAttr = escapeHtml;
